module.exports = __webpack_public_path__ + "static/media/forgotpass.001ac093.svg";